const myDatabaseConfig = {
    type: "DatabaseConfig",
    Name: "myDatabase",
    mySqlUrlorIp: "dmddomy.pl",
    apiPort: 443
  };
  
  export default myDatabaseConfig;
